export {
    FindYourGym as default,
    getFindYourGymServerSideProps as getServerSideProps,
} from '../../../compositions';
